import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddLiveVideo from "../../../containers/superadmin/live-videos/models/add-live-video";
import SearchBar from "../../../containers/superadmin/live-videos/searchbar";
import SuperadminLiveVideosTable from "../../../containers/superadmin/live-videos/table";
import {
  getAllLiveVideosRequest,
  getLiveVideosByCourseRequest,
  getLiveVideosByTeacherRequest,
} from "../../../modules/superadmin-modules/live-videos/Actions";

const SuperadminLiveVideos = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [courseId, setCourseId] = useState(null);
  const [teacherId, setTeacherId] = useState(null);

  useEffect(() => {
    if (courseId) {
      dispatch(getLiveVideosByCourseRequest(courseId));
    } else if (teacherId) {
      dispatch(getLiveVideosByTeacherRequest(teacherId));
    } else {
      dispatch(getAllLiveVideosRequest());
    }
  }, [courseId, teacherId]);

  return (
    <Layout>
      <SearchBar 
        setAdd={setAdd} 
        setCourseId={setCourseId} 
        setTeacherId={setTeacherId} 
      />
      <SuperadminLiveVideosTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
      />
      <AddLiveVideo
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default SuperadminLiveVideos; 